import React from 'react';
import { OrganizationAccessDetailsEdgeCase } from './OrganizationAccessDetailsEdgeCase';

const OrganizationAccessDetailsType1User = ({content,productName}) => {
  return (
    <>
      <OrganizationAccessDetailsEdgeCase content={content} productName={productName} />
    </>
  );
};

export { OrganizationAccessDetailsType1User };
